import { defineStore } from 'pinia';
import userApiService from '@/services/users.api.service';
import { CwxBackend } from '@/types/cwxBackend';

export const useUserStore = defineStore('user', {
  state: () => ({
    userSettings: {} as CwxBackend.IUserInfo,
  }),
  actions: {
    async fetchUserSettings() {
      this.userSettings = await userApiService.getLoggedUserSettings();
    },
  },
  getters: {
    userIsAdministratorOrManager: (state) =>
      state.userSettings?.globalRoles?.includes(CwxBackend.SystemRoleNames.SuperAdmin) ||
      state.userSettings?.globalRoles?.includes(CwxBackend.SystemRoleNames.CustomerAdmin),
    userIsGuest: (state) =>
      state.userSettings?.globalRoles?.includes(CwxBackend.SystemRoleNames.Guest),
    userIsDeputy: (state) =>
      state.userSettings?.isDeputy
  },
});
